import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="footer1-section-area">
        <div className="row">
          <div className="col-lg-12">
            <div className="copyright text-center">
              <a href="#">
                <img src="assets/img/logo/logo1.png" alt="housebox" />
              </a>
              <p>
                © CopyRight&nbsp;2025&nbsp;All Rights Reserved <a href="#" style={{color:"#fdb631"}}><b>RFirms</b></a> -Designed
                by&nbsp;
                <a
                  href="https://digitalraiz.com"
                  target="_blank"
                  style={{ color: "red" }}
                >
                  DigitalRaiz
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
